<template>
    <div class="invite-list">
        <div class="list" @click="go_InviteTeacher">
            <img src="../../assets/img/teacher_img.jpg" alt="邀请老师使用">
            <div @click.stop="goHuoDongGuize(1)"></div>
        </div>
        <div class="list" @click="go_InviteAgent">
            <img src="../../assets/img/agent_img.jpg" alt="邀请代理商使用">
            <div @click.stop="goHuoDongGuize(2)"></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        // 推荐老师
        go_InviteTeacher() {
            this.$router.push({
                path: '/userinfo/invitefriends'
            })
        },
        // 推荐代理商
        go_InviteAgent() {
            this.$router.push({
                path: '/userinfo/inviteagent'
            })
        },
        // 活动规则
        goHuoDongGuize(e) {
            if(e == 1){
                this.$router.push({
                    path: '/userinfo/guize'
                })
            }else{
                this.$router.push({
                    path: '/userinfo/guize2'
                })
            }
        }
    }
}
</script>

<style scoped>
    .invite-list {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
        align-items: center;
    }
    .invite-list>.list {
        display: flex;
        height: 40%;
        position: relative;
        align-items: center;
        padding: 0 30px;
    }
    .invite-list>.list:first-child {
        border-bottom: 1px solid #ccc;
    }
    .invite-list>.list>img {
        width: 100%;
    }
    .invite-list>.list>div {
        position: absolute;
        width: 30%;
        height: 14%;
        right: 16%;
        bottom: 35%;
        border-radius: 20px;
    }
</style>

